import { css } from '@emotion/css';
import {
  primaryBackground,
  primaryDark,
  primaryLight,
  B400,
  N0,
  N400,
} from '@/colors/colorsV1'

export const styContainer = ({ isBorder }) => css`

  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding: 8px 16px;
  ${isBorder 
    && `
      background: ${primaryBackground};
      border: 1px solid ${primaryLight};
      border-radius: 4px;
    `
  }
`

export const styToggleSwitch = css`
  position: relative;
  width: 30px;
  display: inline-block;
  text-align: left;
  top: 8px;
`

export const styCheckbox = css`
  display: none;

  &:checked + label .inner  { 
    margin-left: 0;
  }
  &:checked + label .switch  { 
    right: 5px;
  }
`

export const styLabel = css`
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 0 solid ${N400};
  border-radius: 19px;
`

export const styInner = css`
  display: block;
  width: 60px;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;

  &:before, &:after {
    float: left;
    width: 30px;
    height: 20px;
    padding: 0;
    line-height: 36px;
    color: ${N0};
    font-weight: bold;
    box-sizing: border-box;
  }

  &:before {
    content: "";
    padding-left: 10px;
    background-color: ${B400};
    color: ${N0};
  }

  &:after { 
    content: "";
    padding-right: 10px;
    background-color: ${primaryLight};
    color: ${N0};
    text-align: right;
  }
`

export const stySwitch = css`
  display: block;
  width: 14px;
  height: 14px;
  margin: 0;
  background: ${N0};
  position: absolute;
  top: 3px;
  bottom: 0;
  right: 13px;
  border: 0 solid ${N400};
  border-radius: 19px;
  transition: all 0.3s ease-in 0s;
`

export const styWithLabel = css`
  display: flex;
  flex-flow: row wrap;
`

export const styText = css`
  display: flex;
  justify-content: center;
  flex-flow: column;
  margin-left: 8px;
  color: ${primaryDark};
  font-weight: bold;
`

